export const SNACKBAR_ID = 'fileSnackbar_';
export const LAST_SUCCESSFUL_TASK_ID = 'LAST_SUCCESSFUL_TASK_ID';
